import React from "react";
import { BrowserRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { differenceInMilliseconds } from "date-fns";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress'
import Routes from "./Routes";
import Page from "./views/GeneralComponents/Page";
import "./App.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import 'react-toastify/dist/ReactToastify.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-image-lightbox/style.css";
import "aos/dist/aos.css";
import { getAccessToken, logout } from './redux/actions/authActions';
import { setAuthToken, setRoleName } from './utils/setHeaders';

const App = () => {
  const dispatch = useDispatch();
  const loaderStatus = useSelector(state => state.loaderReducer);

  // dont use useffect because , it dispactches setAuthtoken and other requests fails

  if (localStorage.token) {
    setAuthToken(localStorage.token);
    setRoleName(localStorage.profile);
  }


  if (localStorage.loginTimeStamp && localStorage.refreshToken && localStorage.token) {
    const currentTimeStamp = new Date();
    const firstLogin = new Date(localStorage.firstLogin);
    const loginTimeStamp = new Date(localStorage.loginTimeStamp);

    // 7 days - hard logout (refresh token should also be expired by now)
    const SEVEN_DAYS_MS = 604800000;
    if (differenceInMilliseconds(currentTimeStamp, firstLogin) > SEVEN_DAYS_MS) {
      dispatch(logout());
    }
    // 50 minutes - proactively refresh token before it expires (access token typically expires in 1 hour)
    else {
      const FIFTY_MINUTES_MS = 3000000;
      if (differenceInMilliseconds(currentTimeStamp, loginTimeStamp) >= FIFTY_MINUTES_MS) {
        const data = {
          refreshToken: localStorage.refreshToken
        };
        dispatch(getAccessToken(data));
      }
    }
  }
  // else {
  //   dispatch(logout);
  // }

  return (
    <Page>
      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={{ xs: 'center', sm: 'center' }}
        flexDirection={{ xs: 'column', sm: 'row' }}
        style={{
          display: loaderStatus === false ? 'none' : undefined,
          height: '100%',
          width: '100%',
          position: 'fixed',
          zIndex: 10000,
          backgroundColor: 'lightgray',
          opacity: '75%',
        }} >
        <CircularProgress />
      </Box>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </Page>
  );
};

export default App;
